import { Button } from 'antd'
import React from 'react'

export const Submit = ({submit, body}) => {
  return (
   <Button disabled={!body.anio } type='primary' onClick={submit}>Generar Consulta</Button>
  )
}
